interface SEOData {
    title: string;
    description: string;
    ogTitle: string;
    ogDescription: string;
    keywords: string;
    ogImage?: string;
}

export const SEO_DATA: Record<string, SEOData> = {
    start: {
        title: "Ergotherapie Rottweil - Ganzheitliche und individuelle Therapie",
        description: "Ihre Ergotherapie-Praxis in Rottweil. Spezialisiert auf Neurologie, Psychiatrie und ganzheitliche Therapie. ✓ Barrierefrei ✓ Zentrale Lage ✓ Individuelle Betreuung",
        ogTitle: "Ergotherapie Rottweil - Ihre Praxis für ganzheitliche Therapie",
        ogDescription: "Professionelle Ergotherapie in Rottweil: Neurologie, Psychiatrie, Geriatrie und Pädiatrie. Individuelle Therapien für Ihren Alltag.",
        keywords: "Ergotherapie, Rottweil, Neurologie, Psychiatrie, Therapie, Rehabilitation, Behandlung, Königstraße",
        ogImage: "/images/tree.jpeg",
    },
    neurologie: {
        title: "Neurologie Ergotherapie Rottweil | Schlaganfall & MS Therapie",
        description: "Spezialisierte neurologische Ergotherapie in Rottweil für Schlaganfall, MS, Parkinson & ALS. Individuelle Reha & Hausbesuche für mehr Selbstständigkeit.",
        ogTitle: "Neurologische Ergotherapie Rottweil - Experten für Rehabilitation",
        ogDescription: "Professionelle neurologische Ergotherapie: Behandlung nach Schlaganfall, bei MS, Parkinson und anderen neurologischen Erkrankungen. Individuelle Therapiekonzepte.",
        keywords: "Neurologische Ergotherapie Rottweil, Schlaganfall Reha Rottweil, Multiple Sklerose Therapie, Parkinson Behandlung, ALS Therapie, Hausbesuche Ergotherapie",
        ogImage: "/images/neurology.jpg",
    },
    psychiatrie: {
        title: "Psychiatrische Ergotherapie Rottweil | Depression & Burnout Hilfe",
        description: "Ganzheitliche psychiatrische Ergotherapie in Rottweil bei Depression, Burnout & Angststörungen. Tagesstrukturierung & Kompetenztraining für Ihre psychische Gesundheit.",
        ogTitle: "Psychiatrische Ergotherapie Rottweil - Kompetente Begleitung",
        ogDescription: "Erfahrene psychiatrische Ergotherapie bei Depression, Burnout, Angststörungen und anderen psychischen Erkrankungen. Individuelle und ganzheitliche Behandlung.",
        keywords: "Psychiatrische Ergotherapie Rottweil, Depression Behandlung Rottweil, Burnout Therapie, Angststörungen Hilfe, Tagesstrukturierung, Psychische Gesundheit Rottweil",
        ogImage: "/images/psychiatry_1.jpg",
    },
    paediatrie: {
        title: "Kinder Ergotherapie Rottweil | ADHS & Entwicklungsförderung",
        description: "Kindgerechte Ergotherapie in Rottweil für ADHS, Konzentrationsstörungen & Entwicklungsverzögerungen. Spielerische Förderung für Schule & Alltag.",
        ogTitle: "Pädiatrische Ergotherapie Rottweil - Entwicklung fördern",
        ogDescription: "Kindgerechte ergotherapeutische Behandlung bei ADHS, Entwicklungsverzögerungen und Lernstörungen. Spielerische und individuelle Therapiekonzepte.",
        keywords: "Kinder Ergotherapie Rottweil, ADHS Therapie Kinder, Konzentrationstraining, Entwicklungsförderung, Feinmotorik Kinder, Lernstörungen Behandlung",
        ogImage: "/images/paediatrics.jpg",
    },
    otherOffers: {
        title: "Kurse & Schulungen | Ergotherapie Rottweil",
        description: "Zusatzangebote: Energiemanagement, Legasthenietraining, Elternworkshops, Handtherapie, Migränetherapie & Sexualitätsberatung in Rottweil.",
        ogTitle: "Weitere Angebote der Ergotherapie Rottweil - Kurse & Schulungen",
        ogDescription: "Kurse und Beratung: Fatigue-Management, Legasthenietraining, Elternworkshops, Handtherapie, Migränetherapie und Sexualität - raus aus dem Tabu !",
        keywords: "Ergotherapie Kurse Rottweil, Energiemanagement Schulung, Legasthenietraining, Elternworkshops, Handtherapie, Fatigue Management, Migränetherapie Kern, Sexualitätsberatung Rottweil, Sexualtherapie Workshop, Behinderung Sexualität, Gesundheitskurse Rottweil",
        ogImage: "/images/uns.jpeg",
    },
    netzverbundSchwarzwald: {
        title: "Netzverbund Schwarzwald | Ergotherapie Rottweil",
        description: "Regionales Versorgungsnetzwerk für Menschen mit komplexen psychischen Erkrankungen im Schwarzwald. Koordiniert durch Susan Maier über die ERGOTHERAPIE UND ZEIT(T)RÄUME in Rottweil.",
        ogTitle: "Netzverbund Schwarzwald – Vernetzte Versorgung im Schwarzwald",
        ogDescription: "Bedarfsgerechte Unterstützung und Koordination für Menschen mit schweren psychischen Erkrankungen – zentral organisiert über die Ergotherapiepraxis in Rottweil.",
        keywords: "Netzverbund Schwarzwald, ambulante Versorgung psychisch krank, IVP, Netzverbund Rottweil, psychiatrische Versorgung Schwarzwald, vernetzte Versorgung",
        ogImage: "/images/psychiatry_1.jpg",
    },
    gruppentherapie: {
        title: "Gruppentherapie Angebote | Ergotherapie Rottweil",
        description: "Soziales Kompetenztraining & Gruppenangebote in Rottweil. Gemeinsam stark werden in unseren therapeutischen Gruppen für Kinder & Erwachsene.",
        ogTitle: "Gruppentherapie in Rottweil - Gemeinsam stark",
        ogDescription: "Übersicht über unsere Gruppentherapien: Soziales Kompetenztraining, Gedächtnisgruppen und mehr. Laden Sie unser Info-PDF herunter.",
        keywords: "Gruppentherapie Rottweil, Soziales Kompetenztraining, Gruppenangebote Ergotherapie, Therapiegruppen, Gemeinsam üben",
        ogImage: "/images/uns.jpeg",
    },
    about: {
        title: "Das Team | Ergotherapie Rottweil - Lisa Spreitzer",
        description: "Lernen Sie unser erfahrenes Ergotherapie-Team in Rottweil kennen. Qualifizierte Therapeuten, herzliche Atmosphäre & individuelle Betreuung für Ihren Therapieerfolg.",
        ogTitle: "Über uns - Ihr Ergotherapie-Team in Rottweil",
        ogDescription: "Erfahren Sie mehr über unser Team, unsere Philosophie und unseren ganzheitlichen Therapieansatz. Wir sind für Sie da - persönlich und kompetent.",
        keywords: "Ergotherapie Team Rottweil, Lisa Spreitzer, Therapeuten Vorstellung, Praxis Team, Qualifizierte Ergotherapeuten",
        ogImage: "/images/uns.jpeg",
    },
    praxis: {
        title: "Unsere Praxisräume | Ergotherapie Rottweil",
        description: "Einblick in unsere moderne Ergotherapie-Praxis in Rottweil. Barrierefreie Räume, professionelle Ausstattung & angenehme Atmosphäre für Ihre Therapie.",
        ogTitle: "Unsere Praxis – Ergotherapie Rottweil",
        ogDescription: "Lernen Sie unsere Praxis kennen: ruhige, reizarme Räume für konzentriertes Arbeiten und persönliche Beratung.",
        keywords: "Praxisräume Ergotherapie, Barrierefreie Praxis Rottweil, Therapieräume, Ausstattung Ergotherapie, Praxisrundgang",
        ogImage: "/images/start_image_1.jpeg",
    },
    ergotherapie: {
        title: "Was ist Ergotherapie? | Praxis Rottweil",
        description: "Ergotherapie erklärt: Ganzheitliche Behandlung zur Förderung der Selbstständigkeit in Alltag, Beruf & Schule. Ihr Weg zu mehr Lebensqualität in Rottweil.",
        ogTitle: "Ergotherapie Rottweil - Ganzheitliche Behandlung",
        ogDescription: "Erfahren Sie mehr über unsere ergotherapeutischen Behandlungsmethoden. Wir bieten individuelle und alltagsorientierte Therapien für alle Altersgruppen.",
        keywords: "Was ist Ergotherapie, Ergotherapie Definition, Ganzheitliche Therapie, Rehabilitation Rottweil, Alltagskompetenz fördern",
        ogImage: "/images/tree.jpeg",
    },
    faqs: {
        title: "Häufig gestellte Fragen - Ergotherapie Rottweil | FAQ",
        description: "Finden Sie Antworten auf häufig gestellte Fragen zu unseren ergotherapeutischen Angeboten, Legasthenietraining, Stiftprofis-Programm, Elternworkshops und mehr.",
        ogTitle: "FAQ - Ergotherapie Rottweil",
        ogDescription: "Umfassende Informationen zu unseren Therapieangeboten, Kursen und Programmen. Erfahren Sie mehr über unsere Methoden und Ansätze.",
        keywords: "FAQ Ergotherapie, Legasthenietraining FAQ, AFS-Methode, Stiftprofis Programm, Elternworkshops, Ergotherapie Fragen, Ergotherapie Rottweil FAQ, Netzverbund Schwarzwald"
    },
    "anfahrt-oeffnungszeiten": {
        title: "Anfahrt & Öffnungszeiten – Ergotherapie Rottweil",
        description: "Adresse, Öffnungszeiten, Kontakt und Anfahrtskarte der Ergotherapie-Praxis in Rottweil.",
        ogTitle: "Anfahrt & Öffnungszeiten – Ergotherapie Rottweil",
        ogDescription: "So erreichen Sie uns: Adresse, Öffnungszeiten, Telefonnummer, E-Mail und Lageplan.",
        keywords: "Anfahrt Ergotherapie Rottweil, Öffnungszeiten Ergotherapie, Adresse, Kontakt, Karte",
    },
    contact: {
        title: "Kontakt & Erstgespräch | Ergotherapie Rottweil",
        description: "Kontaktieren Sie die Ergotherapie Rottweil für ein kostenloses Erstgespräch. Füllen Sie unser Kontaktformular aus – wir melden uns zeitnah bei Ihnen.",
        ogTitle: "Kontakt – Ergotherapie Rottweil",
        ogDescription: "Vereinbaren Sie Ihr kostenloses Erstgespräch. Kontaktformular, Telefon und E-Mail – wir sind für Sie da.",
        keywords: "Kontakt Ergotherapie Rottweil, Erstgespräch, Termin vereinbaren, Kontaktformular, Ergotherapie Anfrage",
    },
    impressum: {
        title: "Impressum - Ergotherapie Rottweil",
        description: "Rechtliche Hinweise und Impressum der Ergotherapie Rottweil.",
        ogTitle: "Impressum - Ergotherapie Rottweil",
        ogDescription: "Rechtliche Hinweise und Impressum der Ergotherapie Rottweil.",
        keywords: "Impressum, Rechtliches, Ergotherapie Rottweil",
    },
    datenschutzerklaerung: {
        title: "Datenschutzerklärung - Ergotherapie Rottweil",
        description: "Informationen zum Datenschutz bei der Ergotherapie Rottweil.",
        ogTitle: "Datenschutzerklärung - Ergotherapie Rottweil",
        ogDescription: "Informationen zum Datenschutz bei der Ergotherapie Rottweil.",
        keywords: "Datenschutz, Datenschutzerklärung, Privacy Policy, Ergotherapie Rottweil",
    },
    notFound: {
        title: "Seite nicht gefunden - Ergotherapie Rottweil",
        description: "Die gewünschte Seite wurde nicht gefunden. Besuchen Sie unsere Startseite für Informationen zu unserer Ergotherapie-Praxis in Rottweil.",
        ogTitle: "Seite nicht gefunden - Ergotherapie Rottweil",
        ogDescription: "Diese Seite existiert nicht. Besuchen Sie unsere Startseite für alle Informationen.",
        keywords: "404, Seite nicht gefunden, Ergotherapie Rottweil",
    },
};

export const COMMON_SEO_TAGS = {
    author: "Ergotherapie Rottweil",
    robots: "index, follow",
    language: "de",
    geoRegion: "DE-BW",
    geoPlacename: "Rottweil",
    baseUrl: "https://ergorw.de",
    image: "/images/tree.jpeg"
};
